import { render, staticRenderFns } from "./competency-tap.vue?vue&type=template&id=b3ab434a&scoped=true&"
import script from "./competency-tap.ts?vue&type=script&lang=ts&"
export * from "./competency-tap.ts?vue&type=script&lang=ts&"
import style0 from "./competency-tap.scss?vue&type=style&index=0&id=b3ab434a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ab434a",
  null
  
)

export default component.exports